import { onMounted, onUnmounted, reactive } from "vue";
import type { IScrollInfo } from "~/shared/interfaces/composables";

const MIN_SCROLL_TO_TRACK_DIRECTION = 50;

export function useWindowScroll(): IScrollInfo {
  const scrollInfo = reactive<IScrollInfo>({
    scrollTop: 0,
    isScrollDown: false,
  });

  let prevScrollState = 0;
  let prevScrollHeight = document.documentElement.scrollHeight;

  function handleScroll() {
    const currentScrollHeight = document.documentElement.scrollHeight;

    if (prevScrollHeight !== currentScrollHeight) {
      prevScrollHeight = currentScrollHeight;
      return;
    }

    const currentScroll = window.scrollY;

    scrollInfo.scrollTop = currentScroll;
    scrollInfo.isScrollDown =
      currentScroll > prevScrollState &&
      currentScroll > MIN_SCROLL_TO_TRACK_DIRECTION;

    prevScrollState = currentScroll;
  }

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return scrollInfo;
}
